export default __webpack_public_path__ + "static/zakrzewski-bac8f7e9b45fb84a9c5ddab7a79a9cd5.jpg";